import { useTranslation } from "react-i18next";

export default function LanguageToggle() {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <select
      className="language-select"
      value={i18n.language}
      onChange={(e) => changeLanguage(e.target.value)}
      aria-label={t("language.selector")}
    >
      <option value="en">{t("language.english")}</option>
      <option value="ga">{t("language.irish")}</option>
    </select>
  );
}
